import styled from 'styled-components'

export const CurrentWrapper = styled.div`
  opacity: 0.5;
  pointer-events: none;
`
